import httpCommon from '@/utils/http-common'
import { publicPages } from '.'
import { useNotification } from '@/hooks/useNotification'
import { useAuthStore } from '@/stores/useAuthStore'

const RegisterInterceptor = router => {
  // In your interceptor error handler callback
  httpCommon.interceptors.response.use(
    res => {
      return res
    },
    async err => {
      const notification = useNotification()
      const auth = useAuthStore()
      const { logout } = auth
      const current = router.currentRoute.value
      const status = err?.response?.status ?? null

      if (status == null) {
        return Promise.reject(err)
      }

      if (status === 401 && !publicPages.includes(router.currentRoute.path)) {
        // Halaman tertentu sesuai tambahan redirect401 di meta: ke page-expired
        if (current?.meta?.redirect401 === 'page-expired') {
          const errorCode = err?.response?.data?.data?.error_code ?? null

          // Session faults (SESSION_EXPIRED / SESSION_INVALID / SESSION_MISSING)
          // are about the caller, not the link, so the expired-link page would be
          // misleading. Send them to login with the deep link preserved instead.
          // Token faults (TOKEN_EXPIRED / TOKEN_INVALID) keep the expired page.
          //
          // Unauthenticated vendor/DIC token routes never match, so their
          // existing behaviour is untouched.
          const isSessionFault = String(errorCode ?? '').startsWith('SESSION_')
          const isSessionExpiry = isSessionFault && auth.isAuthenticated

          if (!isSessionExpiry) {
            // Untuk token-based routes, tampilkan pesan dari response
            const errorMessage = err?.response?.data?.message || 'Token has expired.'
            notification.error(errorMessage)
            router.replace('/page-expired')
            return Promise.reject(err) // biarkan caller tahu ini error
          }

          notification.error('Your session has expired, please re-login')
          const returnTo = current?.fullPath
          await logout()
          auth.returnUrl = returnTo
          router.replace('/login')
          return Promise.resolve()
        }

        notification.error('Your session has expired, please re-login')
        await logout()
        router.replace('/login')
        return Promise.resolve()
      }
      return Promise.reject(err)
    }
  )
}

export default RegisterInterceptor
